/**
 * Routing — Document 6 §8.2.
 *
 * `AppShell` is the authentication gate for everything inside it: it redirects
 * an anonymous visitor to login and a signed-in one without a selected
 * instructor to the picker. Screens below it can assume both.
 *
 * This is convenience, not security. The server rejects every unauthenticated
 * and cross-tenant request on its own (Architecture §7); hiding a route in the
 * frontend is not authorization.
 */

import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './components/AppShell.js';
import { Dashboard } from './pages/Dashboard.js';
import { HealthCheck } from './pages/HealthCheck.js';
import { Instructors } from './pages/Instructors.js';
import { InstructorSelect } from './pages/InstructorSelect.js';
import { Login } from './pages/Login.js';
import { Placeholder } from './pages/Placeholder.js';
import { PlatformDashboard } from './pages/PlatformDashboard.js';
import { PlatformLogin } from './pages/PlatformLogin.js';
import { ReportHistory } from './pages/ReportHistory.js';
import { ReportRender } from './pages/ReportRender.js';
import { ReportWizard } from './pages/ReportWizard.js';
import { StudentCreate } from './pages/StudentCreate.js';
import { StudentList } from './pages/StudentList.js';
import { StudentProfile } from './pages/StudentProfile.js';
import { StudioSettings } from './pages/StudioSettings.js';

export const router = createBrowserRouter([
  { path: '/giris', element: <Login /> },
  { path: '/egitmen-secimi', element: <InstructorSelect /> },
  // Opened by a headless browser holding a render token, never by a person.
  { path: '/rapor-cikti/:token', element: <ReportRender /> },
  // The admin panel — outside AppShell entirely, since AppShell assumes a
  // studio session and would bounce an admin straight back to /giris.
  { path: '/yonetim/giris', element: <PlatformLogin /> },
  { path: '/yonetim', element: <PlatformDashboard /> },
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/panel" replace /> },
      { path: 'panel', element: <Dashboard /> },
      { path: 'ogrenciler', element: <StudentList /> },
      { path: 'ogrenciler/yeni', element: <StudentCreate /> },
      { path: 'ogrenciler/:studentId', element: <StudentProfile /> },
      { path: 'rapor-olustur', element: <ReportWizard /> },
      { path: 'egitmenler', element: <Instructors /> },
      { path: 'raporlar', element: <ReportHistory /> },
      { path: 'ayarlar', element: <StudioSettings /> },
      { path: 'saglik', element: <HealthCheck /> },
      { path: '*', element: <Placeholder title="Sayfa bulunamadı" sprint="—" /> },
    ],
  },
]);
